/* global window, Blob, AudioContext */
// eslint-disable-next-line import/no-duplicates
import AudioConversionWorker from 'worker-component!./audioConversion.worker';
// eslint-disable-next-line import/no-duplicates
import { IWorkerMessageConfigure, IWorkerMessageConvert } from './audioConversion.worker';
import { WorkerMessageType } from 'app/utils/audioConversionConstants';
import { readBlob } from './env';
import appConfig from 'app/config/client';
import { getAssetBaseURL } from 'app/config/types/Environment';

export async function convertAudioBlob(blob: Blob): Promise<Blob> {
  const audioData = await readBlob(blob);
  const { mp3Data } = await convertAudio(audioData);
  return new Blob(mp3Data, { type: 'audio/mp3' });
}

interface IResult {
  mp3Data: ArrayBufferLike[];
  sampleRate: number;
}

export async function convertAudio(audioData: ArrayBuffer): Promise<IResult> {
  const audioContext = new AudioContext();

  if (audioContext === undefined) {
    throw new Error('Browser does not support WebAudio API');
  }

  const buffer = await new Promise<AudioBuffer>((resolve, reject) =>
    audioContext.decodeAudioData(audioData, resolve, reject));

  const channelData: ArrayBufferLike[] = [];

  for (let i = 0; i < buffer.numberOfChannels; ++i) {
    channelData.push(buffer.getChannelData(i).buffer);
  }

  const promise: Promise<IResult> = new Promise((resolve, reject) => {
    const worker = new AudioConversionWorker();
    worker.addEventListener('message', (event: any) => {
      const mp3Data: ArrayBufferLike[] = event.data.buffers;
      resolve({
        mp3Data,
        sampleRate: audioContext.sampleRate,
      });
    });
    worker.addEventListener('error', (event) =>
      reject(new Error('MP3 conversion failed.')));

    const workerMessageConfigure: IWorkerMessageConfigure = {
      assetBaseUrl: getAssetBaseURL(appConfig.environment),
      origin: window.origin,
      type: WorkerMessageType.Configure,
    };

    const workerMessageConvert: IWorkerMessageConvert = {
      channelData,
      sampleRate: audioContext.sampleRate,
      type: WorkerMessageType.Convert,
    };

    worker.postMessage(workerMessageConfigure);
    worker.postMessage(workerMessageConvert, channelData);
  });

  return await promise;
}
